import { service } from "@ember/service";
import Route from "@ember/routing/route";
import { invoiceList } from "glesys-controlpanel/data/invoice/builders";

export default class OrganizationInvoicesRoute extends Route {
  @service session;
  @service store;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  async model() {
    let { organization } = this.modelFor("organization");

    let invoices = await this.store.request(invoiceList(organization.id));

    return {
      invoices: invoices.content.data,
      organization,
    };
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    controller.set("selectedInvoices", []);
  }
}
